import { Box, Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";

const MenuActions = (props) => {
  const [anchormenuActions, setAnchormenuActions] = useState(null);
  const menuActionsOpen = Boolean(anchormenuActions);

  const handleToggleMenuActions = (event) => {
    setAnchormenuActions(event.currentTarget);
  };

  const handleClose = (event) => {
    setAnchormenuActions(null);
  };

  return (
    <div>
      <Button
        id="fade-button"
        aria-controls={menuActionsOpen ? "fade-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={menuActionsOpen ? "true" : undefined}
        onClick={handleToggleMenuActions}
        sx={{ color: "white", ml: "auto" }}
        disableRipple={true}
      >
        [{props.buttonName}]
      </Button>
      <Menu
        anchorEl={anchormenuActions}
        open={menuActionsOpen}
        onClose={handleClose}
      >
        {props.menuActions == undefined && props.menuActions?.length == 0 ? (
          <MenuItem>No Actions</MenuItem>
        ) : (
          props.menuActions?.map((item) => (
            <MenuItem
              key={item.Name}
              onClick={item.Action}
              sx={{ display: item.Display }}
            >
              {item.Name}
            </MenuItem>
          ))
        )}
      </Menu>
    </div>
  );
};

export default MenuActions;
